import { createContext, useEffect, useReducer } from "react";
import blueTheme from "../themes/blueTheme";
import defaultTheme from "../themes/defaultTheme";

export const ThemeContext = createContext<any>(defaultTheme);

//define theme values
const setCSSVariables = (theme: any) => {
  for (const value in theme) {
    document.documentElement.style.setProperty(`--${value}`, theme[value]);
  }
};

// Apply CSS class to root element for Tailwind theme
const applyThemeClass = (themeName: string) => {
  const root = document.documentElement;
  // Remove all theme classes
  root.classList.remove("blue");

  // Add theme class if not default
  if (themeName === "BLUE") {
    root.classList.add("blue");
  }
};

const themes = {
  default: defaultTheme,
  blue: blueTheme
};

export const themeReducer = (state: any, action: any) => {
  let link: any = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.getElementsByTagName("head")[0].appendChild(link);
  }
  switch (action.type) {
    case "BLUE":
      setCSSVariables(themes.blue);
      applyThemeClass("BLUE");
      link.href = "https://np-web-uploads.s3.eu-north-1.amazonaws.com/favicon-128x128.png";
      return { theme: themes.blue };
    case "GREEN":
      setCSSVariables(themes.default);
      applyThemeClass("GREEN");
      link.href = "https://np-web-uploads.s3.eu-north-1.amazonaws.com/favicon.ico";
      return { theme: themes.default };
    default:
      link.href = "https://np-web-uploads.s3.eu-north-1.amazonaws.com/favicon.ico";
      setCSSVariables(state);
      return state;
  }
};

// Get initial theme from environment variable
const getInitialTheme = () => {
  const envTheme = process.env.REACT_APP_THEME;
  return envTheme === "BLUE" ? themes.blue : themes.default;
};

export const ThemeContextProvider = ({ children }: any) => {
  const [state, dispatch] = useReducer(themeReducer, {
    theme: getInitialTheme()
  });

  // Initialize theme based on environment variable
  useEffect(() => {
    const envTheme = process.env.REACT_APP_THEME;
    if (envTheme === "BLUE") {
      dispatch({ type: "BLUE" });
    } else {
      dispatch({ type: "GREEN" });
    }
  }, []);

  return <ThemeContext.Provider value={{ ...state, dispatch }}>{children}</ThemeContext.Provider>;
};
